/**
 * Application Configuration
 * 
 * Central configuration file for environment variables and app settings.
 * All environment variables should be accessed through this file.
 */

/**
 * Backend API Base URL
 * Default: http://localhost:6100
 */
export const API_BASE_URL = (import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000/api').replace(/\/?$/, '/')

/**
 * API key for email-login endpoint (POST /auth/email-login).
 * Set VITE_LOGIN_API_KEY in .env to match backend LOGIN_API_KEY.
 */
export const LOGIN_API_KEY = import.meta.env.VITE_LOGIN_API_KEY || ''

/**
 * Environment
 */
export const IS_PRODUCTION = import.meta.env.PROD
export const IS_DEVELOPMENT = import.meta.env.DEV

/**
 * App Metadata
 */
export const APP_NAME = 'Athena'
export const APP_VERSION = '1.0.0'

/** Super admin email; only this user can promote/demote admins in user management. */
export const SUPER_ADMIN_EMAIL = 'admin@localhost'

/** localStorage key for session JWT (used to know if user is logged in without API call). */
export const ATHENA_SESSION_TOKEN = 'athena-session-token'

